module.exports = __webpack_public_path__ + "static/media/design-process.5410574a.svg";